import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import { world } from '../../languages';
import axios from '../../utils/axios';

type UpdateFolderFields = {
    parent_id?: null | number;
    title?: string;
    type?: FOLDER_DIRECTORIES;
    world?: string;
};

export const updateFolder = (
    fields: UpdateFolderFields,
    config: { directory: FOLDER_DIRECTORIES; id: number }
) => {
    const queryFilter = `{ type: ${config.directory}, id: ${config.id}, world: "${world}" }`;

    return axios.post(API_URLS.FOLDERS.UPDATE, {
        fields,
        queryFilter
    });
};
